import React, { memo, useState } from 'react';
import CRMTopPanel from './top-panel/TopPanel';
import useMenu from 'hooks/useMenu';
import WidgetAddModal from './WidgetAddModal';
import { useQuery } from 'react-query';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import useSearch from 'hooks/useSearch';
import Widget from './Widget';

export default memo(function Dashboard() {
  const { hasChild } = useMenu();
  const axiosPrivate = useAxiosPrivate();
  const query = useSearch();
  const view = (code) => hasChild('CRM', code);
  const [open, setOpen] = useState(false);

  const [hasError, setHasError] = useState(false);

  const { data: widgets, refetch } = useQuery({
    queryKey: ['/admin/widgets/widgets/{Dashboard_id}', query.get('dashboard')],
    queryFn: async function () {
      const response = await axiosPrivate.get(
        `/admin/widgets/widgets/${query.get('dashboard')}`
      );
      return response.data.data;
    },
    enabled: !hasError && !!query.get('dashboard'),
    onSuccess: (data) => {},
    onError: (error) => {
      setHasError(true);
    },
    retry: false,
  });

  return (
    <div className='h-full'>
      <CRMTopPanel
        addBlock={view('CRM_ADD_BLOCK')}
        setOpenWidgetModal={setOpen}
      />
      {open && (
        <WidgetAddModal open={open} setOpen={setOpen} refetchFn={refetch} />
      )}

      <div className='h-[calc(100%-60px)] grid grid-cols-3 gap-3 pt-2 overflow-y-auto my-scroll'>
        {widgets?.map((widget) => (
          <div key={widget?.id} className='grid-item'>
            <Widget info={widget} />
          </div>
        ))}
      </div>
    </div>
  );
});
